<template>
   <PageFull header="Адм. отправители" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <SendersList />
            </div>  
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import SendersList from '@/components/admin/SendersList.vue' 
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        SendersList,
        PageFull
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>